// import { getAllSuggestByTableId } from "@/api/activiti";
import { editTourFormOA , getDictDataByType } from "@/api/index";
export default {
  components: {   },

  data() {
    const validateMobile = (rule, value, callback) => {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      gatherCodeArr: [],
      adcodeData: "",
      //意见保存未提交  意见保存已经提交
      formCommit: {
        remark: "",
      },
      contentForm: {
        writeSuggestContent: "",
        userName: "",
        createTime: "",
      },
      suggestContentOne: "",
      suggestContentValue: "",
      labelAndValue: true,
      allSuggest: [],
      oftenSuggestForm: {
        createBy: "",
        oftenSuggestContent: "",
      },
      form: {
        // 添加或编辑表单对象初始化数据
        ajbh: "",
        slbh: "",
        xmmc: "",
        tdwz: "",
        ydmj: "",
        ghyt: "",
        yddw: "",
        lxr: "",
        lxrdh: "",
        cksjr: "",
        sjrq: "",
        fj: "",
        remark: "",
        businessId: "",
        pointTxt: "",
      },
      type: "",
      backRoute: "",
      nodeId: "",
      userQm: "",
      suggestStatus: null,
      modalsign: false,
      formItem: {
        username: "",
        password: "",
      },
      userloading: false,
      userinfo1: {},
      signinx: 0,
      spinshow1: false,
      upfiletype: {
        dwg: false,
        txt: false,
      },
      currentStatus: "add",
      modalTaskVisible: false,
      lcloading: false,
      lcData: [], // 表单数据
      currentAdd: {},
      dataTree: [],
      remarkForm: {},
      dataTitle: "",
      otherCode: "",
      gatherForm: {
        monomerId: "",
        monomerName: "",
        code: "",
        administrativeLocation: "",
        longitude: null,
        latitude: null,
        newFind: 1,
        mainType: "",
        subtype: "",
        basicType: "",
        imageStr: "",
        videoStr: "",
        // 性质与特征
        appearance: "",
        intrinsicProperty: "",
        composition: "",
        geneticMechanism: "",
        scaleAndVolume: "",
        envBackground: "",
        relatedThings: "",
        // 旅游区域进出口条件
        externalRoad: "",
        ambitusCity: "",
        ambitusCityDistance: "",
        centreName: "",
        centreDistance: "",
        touristAreaName: "",
        touristAreaDistance: "",
        otherInstructionsOne: "",
        // 保护与开发现状
        preservationStatus: "",
        developed: 1,
        protective: 1,

        scenicSpotName: "",
        scenicSpotGrade: "",
        scenicAreaName: "",
        scenicAreaGrade: "",
        visitorReception: "",
        otherInstructionsTwo: "",
        // 资源开发利用方向
        directionlist: [],
        // 旅游资源单体评价
        monomerScore: "",
        maybeGrade: "",
        filledBy: "",
        contactNumber: "",
        censusDate: "",
        // 存储单体评价列表的字段
        tourismResourcesJson: "",
        // 特征数据
        featureDataList: [],
        featureDataJson: "",
        areaCode: "",
        areaName: "",
        // 类别汉字的三个字段
        mainTypeName: "",
        subtypeName: "",
        basicTypeName: "",
      },
      remarkScoreRule:{},
      //存储采集信息的类型
      typeArr: window.g.tourismBasicTypes,
      //   存储亚类型
      secondArr: [],
      //   存储基本类型
      basicArr: [],
      protectStatus: ["保存良好", "少量破损", "破损严重"],
      famousLevel: ["一级", "二级", "三级", "四级", "五级"],

      //   上传图片文件时候的限制
      uploadPhotoType: ".jpg,.jpeg,.png,.webp",
      //   上传视频文件时候的限制
      uploadVideoType: ".mp4",
      //   基本信息表单的验证规则
      baseRule: {},
      propertyRule: {
        appearance: [{ required: false }],
        intrinsicProperty: [{ required: false }],
        composition: [{ required: false }],
        geneticMechanism: [{ required: false }],
        scaleAndVolume: [{ required: false }],
        envBackground: [{ required: false }],
        relatedThings: [{ required: false }],
      },
      famousRule: {
        externalRoad: [{ required: false }],
        ambitusCity: [{ required: false }],
        ambitusCityDistance: [{ required: false, type: "number" }],
        centreDistance: [{ required: false, type: "number" }],
        touristAreaDistance: [{ required: false, type: "number" }],
        otherInstructionsOne: [{ required: false }],
      },
      protectRule: {
        preservationStatus: [{ required: false }],
        developed: [{ required: false }],
        protective: [{ required: false }],
        scenicSpotName: [{ required: false }],
        scenicSpotGrade: [{ required: false }],
        visitorReception: [{ required: false, type: "number" }],
        otherInstructionsTwo: [{ required: false }],
      },
      developRule: {
        directionlist: [{ required: false }],
      },
      // 单体评价的验证规则
      remarkRule: {},
      // 禁用的
      disabled: true,
      // 记录上传过的图片的id
      photoArr: [],
      videoArr: [],
      // 记录图片的url
      photoUrlArr: [],
      videoUrlArr: [],
      // 显示审批数据的标志变量
      showCheckList: false,
      player: null,
      xjxdpsResult: "",
      xjzjResult: "",
      sjzjResult: "",
      sjzjResult2: "",
      // 是从菜单中跳过来的，true的时候，返回的按钮就不显示
      isFromMenu: true,
      userInfoData: {},
      submitLoading: false,
      tabName: "baseInfo",
      // 对外道路情况可选项
      roadConditionArr: [],
      isShowNull: false,
    };
  },
  props: {
    tableId:{
      type: String,
      default: "",
    }
  },
  created() {
    this.init();
    if (this.type == 0) {
      // 新增表单数据
      this.gatherForm.censusDate = this.getDate();
      let roles = JSON.parse(window.localStorage.getItem("userInfo"));
      this.gatherForm.filledBy = roles.username;
      this.userInfoData = roles;
    }
  },
  methods: {
    countRemarkScore() {
      if (
        this.remarkForm.ornamentalValue &&
        this.remarkForm.humanisticValue &&
        this.remarkForm.popularity &&
        this.remarkForm.rarityAndPeculiarity &&
        this.remarkForm.saveIntegrity &&
        this.remarkForm.scaleAndAbundance &&
        this.remarkForm.suitableTravelPeriod &&
        this.remarkForm.snvironmentAndSafety
      ) {
        this.countScoreGrade(JSON.stringify([this.remarkForm]));
      }
    },

    joinCode() {
      if (
        this.gatherForm.monomerId &&
        this.gatherForm.longitude &&
        this.gatherForm.latitude &&
        this.gatherForm.subtype
      ) {
        if (this.gatherForm.basicType) {
          this.gatherCodeArr[3] = this.gatherForm.basicType;
          this.gatherCodeArr[4] = this.gatherForm.monomerId;
        } else {
          this.gatherCodeArr[3] = this.gatherForm.subtype;
          this.gatherCodeArr[4] = this.gatherForm.monomerId;
        }
        this.gatherForm.code = this.gatherCodeArr.join("-");
      }
    },
    init() {
      this.getRoadConditionData();
      // 处于编辑的状态
      editTourFormOA({ id: this.tableId }).then((res) => {
        if (res.code == 200 && res.message == "success" && res.result) {
          this.gatherForm = res.result;
          this.giveSecondArr(this.gatherForm.mainType);
          this.giveBasicArr(this.gatherForm.subtype);
          this.gatherForm.newFind = parseInt(res.result.newFind);
          this.gatherForm.protective = parseInt(res.result.protective);
          this.gatherForm.developed = parseInt(res.result.developed);
          let tempObj = JSON.parse(this.gatherForm.tourismResourcesJson)[0];
          if (
            tempObj.hasOwnProperty("ornamentalValue") &&
            tempObj.ornamentalValue
          ) {
            this.remarkForm.ornamentalValue = Number(
              tempObj.ornamentalValue
            );
          } else {
            this.remarkForm.ornamentalValue = 0;
          }
          if (
            tempObj.hasOwnProperty("humanisticValue") &&
            tempObj.humanisticValue
          ) {
            this.remarkForm.humanisticValue = Number(
              tempObj.humanisticValue
            );
          } else {
            this.remarkForm.humanisticValue = 0;
          }
          if (tempObj.hasOwnProperty("popularity") && tempObj.popularity) {
            this.remarkForm.popularity = Number(tempObj.popularity);
          } else {
            this.remarkForm.popularity = 0;
          }
          if (
            tempObj.hasOwnProperty("rarityAndPeculiarity") &&
            tempObj.rarityAndPeculiarity
          ) {
            this.remarkForm.rarityAndPeculiarity = Number(
              tempObj.rarityAndPeculiarity
            );
          } else {
            this.remarkForm.rarityAndPeculiarity = 0;
          }
          if (
            tempObj.hasOwnProperty("saveIntegrity") &&
            tempObj.saveIntegrity
          ) {
            this.remarkForm.saveIntegrity = Number(tempObj.saveIntegrity);
          } else {
            this.remarkForm.saveIntegrity = 0;
          }
          if (
            tempObj.hasOwnProperty("scaleAndAbundance") &&
            tempObj.scaleAndAbundance
          ) {
            this.remarkForm.scaleAndAbundance = Number(
              tempObj.scaleAndAbundance
            );
          } else {
            this.remarkForm.scaleAndAbundance = 0;
          }
          if (
            tempObj.hasOwnProperty("suitableTravelPeriod") &&
            tempObj.suitableTravelPeriod
          ) {
            this.remarkForm.suitableTravelPeriod = Number(
              tempObj.suitableTravelPeriod
            );
          } else {
            this.remarkForm.suitableTravelPeriod = 0;
          }
          if (
            tempObj.hasOwnProperty("snvironmentAndSafety") &&
            tempObj.snvironmentAndSafety
          ) {
            this.remarkForm.snvironmentAndSafety = Number(
              tempObj.snvironmentAndSafety
            );
          } else {
            this.remarkForm.snvironmentAndSafety = 0;
          }
        
          if (!this.gatherForm.directionlist) {
            this.gatherForm.directionlist = [];
          }
          if (!this.gatherForm.featureDataList) {
            this.gatherForm.featureDataList = [];
          }
          if (
            this.gatherForm &&
            this.gatherForm.imageList &&
            this.gatherForm.imageList.length <= 0
          ) {
            this.isShowNull = true;
          } else {
            this.isShowNull = false;
          }
        }
        if (this.type == 2) {
          this.disabled = true;
        }
      });
      if (this.type != 0) {
        //通过表单id获取所有意见框及其内容
        this.getAllSuggestListByTableId();
      } 
    },
    // 请求对外道路情况的可选项
    getRoadConditionData() {
      getDictDataByType("roadCondition").then((res) => {
        if (res.code == 200 && res.message == "success") {
          this.roadConditionArr = res.result;
        }
      });
    },
    exportBtn() {
      window.location.href =
        `xboot/lsyd/createLsydWord?id=` + this.$route.query.id;
    },
    instance(type, content) {
      const title = "请将表单填写完整";
      switch (type) {
        case "error":
          this.$Modal.error({
            title: title,
            content: content,
          });
          break;
      }
    },
    history(v) {
      if (!this.procDefId) {
        this.$Message.error("流程实例ID不存在");
        return;
      }
      let query = { id: this.procDefId, backRoute: this.$route.name };
      this.$router.push({
        name: "insImg_detail",
        query: query,
      });
    },
    getAllSuggestListByTableId() {
      this.formCommit.remark = 2;
      getAllSuggestByTableId(this.form.id, this.formCommit).then((res) => {
        if (res.success === true) {
          this.allSuggest = res.result;
          //将原来填写的删除
          $("#writeSuggestContent").html("");
          $("#userName").html("");
          $("#createTime").html("");

          this.getSaveButNotCommit();
        }
      });
    },
    //获取保存未提交的
    getSaveButNotCommit() {
      //查询保存但未提交的
      this.formCommit.remark = 1;
      getAllSuggestByTableId(this.form.id, this.formCommit).then((res) => {
        if (res.success === true) {
          var suggentContent = res.result;
          for (var i = 0; i < suggentContent.length; i++) {
            if (
              this.nodeId == suggentContent[i].suggestDeploy.nodeId &&
              suggentContent[i].suggestMessageList.length > 0
            ) {
              this.suggestContentValue =
                suggentContent[i].suggestMessageList[0].suggestContent;
              $("#writeSuggestContent").html(
                suggentContent[i].suggestMessageList[0].suggestContent
              );
              $("#userName").html(
                JSON.parse(window.localStorage.getItem("userInfo")).username
              );
              $("#createTime").html(
                suggentContent[i].suggestMessageList[0].createTime
              );
            }
          }
        }
      });
    },
    selectChange(v) {
      if (v) {
        this.form.sjrq = v;
      }
    },
    //txt上传
    txtBeforupload(selectedFile) {
      if (this.form.pointTxt && this.upfiletype.dwg) {
        let that = this;
        return new Promise(function (resolve, reject) {
          that.$Modal.confirm({
            title: "提示",
            content: "<p>当前已上传dwg文件，是否确认替换上传txt？",
            onOk: () => {
              that.upfiletype.txt = true;
              that.upfiletype.dwg = false;
              resolve();
            },
            onCancel: () => {
              that.upfiletype.txt = false;
              that.upfiletype.dwg = true;
              reject();
              return false;
            },
          });
        });
      } else {
        this.upfiletype.txt = true;
        this.upfiletype.dwg = false;
      }
      if (selectedFile.type == "text/plain") {
        let reader = new FileReader();
        reader.readAsText(selectedFile);
        var that = this;
        reader.onload = function (oFREvent) {
          //读取完毕从中取值
          var pointTxt = oFREvent.target.result;
          if (pointTxt) {
            let result = this.publicMethod.selectTextFile(pointTxt); //通用txt封装方法
            if (result.inputPolygons && result.inputPolygons.length > 0) {
              that.initSource(result.inputPolygons);
              that.$Message.success("上传坐标成功！");
            } else {
              that.form.pointTxt = "";
              that.$Message.warning({
                content: "txt的坐标文件不正确",
              });
            }
          } else {
            this.form.pointTxt = "";
            this.$Message.info("txt的坐标文件不正确");
          }
        };
      } else {
        this.form.pointTxt = "";
        this.$Message.info("请上传txt文件");
      }
      return false;
    },
    initSource(geomtry) {
      if (geomtry) {
        //根据上传txt坐标点
        var polygonJson = [];
        for (var item in geomtry) {
          var point = geomtry[item].getCoordinates()[0][0];
          // point.push(point[0]);
          polygonJson.push(point);
        }
        this.form.pointTxt = JSON.stringify({ rings: polygonJson });
      }
    },
    addkffx() {
      if (!this.disabled) {
        this.gatherForm.directionlist.push({
          planFileName: "",
          utilizationDrection: "",
        });
      }
    },
    addtzsj() {
      if (!this.disabled) {
        this.gatherForm.featureDataList.push({
          planFeature: "",
          planFeatureValue: "",
        });
      }
    },
    /*
     *@description: 删除开发方向事件
     *@author: qqjuanqq
     *@date: 2023-04-06 11:18:00
     *@version: V1.0.0
     */
    deleteItem(index) {
      if (!this.disabled) {
        this.gatherForm.directionlist.splice(index, 1);
      }
    },
    deleteItemFeature(index) {
      if (!this.disabled) {
        this.gatherForm.featureDataList.splice(index, 1);
      }
    },
    // 选择主类型之后通过选择框的onchange事件给亚类型赋值
    giveSecondArr(val) {
      this.typeArr.forEach((item) => {
        if (this.gatherForm.mainType == item.key) {
          this.secondArr = item.children;
          this.gatherForm.mainTypeName = item.value;
        }
      });
    },
    // 选择亚类型之后给基本类型赋值
    giveBasicArr(val) {
      this.secondArr.forEach((item) => {
        if (this.gatherForm.subtype == item.key) {
          this.basicArr = item.children;
          this.gatherForm.subtypeName = item.value;
        }
      });
      // this.joinCode();
    },
    BasicInfo(val) {
      this.basicArr.forEach((item) => {
        if (item.key == val) {
          this.gatherForm.basicTypeName = item.value;
        }
      });
      // this.joinCode();
    },
    // 获得填表单的时间
    getDate() {
      const date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month > 9 ? month : "0" + month;
      day = day > 9 ? day : "0" + day;
      return `${year}-${month}-${day}`;
    },
    // 清空表单的函数
    clearForm() {
      this.otherCode = "";
      this.$refs.addBaseForm.resetFields();
      this.$refs.addPropertyForm.resetFields();
      this.$refs.addFamousForm.resetFields();
      this.$refs.addProtectForm.resetFields();
      this.$refs.addDevelopForm.resetFields();
      this.$refs.addMarkForm.resetFields();
      this.$refs.remarkForm.resetFields();
      this.$refs.addFeatureDataForm.resetFields();
      this.gatherForm.relatedThings = "";
      this.gatherForm.imageStr = "";
      this.rowData.imageStr = "";
      this.gatherForm.videoStr = "";
      this.rowData.videoStr = "";
      this.gatherForm.tourismResourcesJson = "";
      this.rowData.tourismResourcesJson = "";
      // 上传列表清空
      this.$refs.photoUpload.clearFiles();
      this.$refs.videoUpload.clearFiles();
      this.gatherForm.featureDataList = [];
      this.gatherForm.directionlist = [];
    },
  },
  watch: {
    "gatherForm.subtype": {
      handler(newVal, oldVal) {
        this.gatherCodeArr[3] = newVal;
      },
    },
    "gatherForm.basicType": {
      handler(newVal, oldVal) {
        this.gatherCodeArr[3] = newVal;
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mapbase/detailItem/detailItem.js